import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import {
    SimpleFlexbox,
    Text,
    CrossSell,
    Picture,
    Anchor
} from 'ctm-components';

import { pageContext } from 'ctm-util-functions';

import { configModel } from '../../client/app_config_model';

import styles from './404.css';

class ErrorContainer404 extends Component {

    getHeader = () => {
        const brandCode = configModel.getModels().pageSchemaModel.getSettings().brand;
        const brandCodePath = brandCode === 'choo' ? 'choo' : 'ctm';
        const brandAlt = brandCode === 'choo' ? 'Choosi Logo' : 'Comparethemarket.com.au - We got your back. Simples.';
        const logoProps = {
            elementProps: {
                source: [
                    {
                        srcSet: `/evt/assets/brand/${brandCodePath}/images/logo-large.png, /evt/assets/brand/${brandCodePath}/images/logo-large@2x.png 2x`,
                        media: '(min-width: 992px)'
                    },
                    {
                        srcSet: `/evt/assets/brand/${brandCodePath}/images/logo-sm.png, /evt/assets/brand/${brandCodePath}/images/logo-sm@2x.png 2x`,
                        media: '(min-width: 768px)'
                    },
                    {
                        srcSet: `/evt/assets/brand/${brandCodePath}/images/logo-xs.png, /evt/assets/brand/${brandCodePath}/images/logo-xs@2x.png 2x`
                    }
                ],
                image: {
                    alt: brandAlt,
                    src: `/evt/assets/brand/${brandCodePath}/images/logo-large.png`
                }
            }
        };

        return (
            <SimpleFlexbox containerFluid bgColor="brand_base_0" border="bottom">
                <SimpleFlexbox container>
                    <SimpleFlexbox row variant="header">
                        <SimpleFlexbox xs={12} sm={6} md={8}>
                            <Picture {...logoProps} />
                        </SimpleFlexbox>
                    </SimpleFlexbox>
                </SimpleFlexbox>
            </SimpleFlexbox>
        );
    };

    getFooter = () => {
        const pictureProps = {
            elementProps: {
                image: {
                    src: '//cdn.ywxi.net/meter/www.comparethemarket.com.au/101.gif',
                    title: 'McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams',
                    alt: 'McAfee SECURE sites help keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams'
                }
            },
            visualProps: {
                variant: 'mcafeeLogo'
            }
        };
        const brandCode = configModel.getModels().pageSchemaModel.getSettings().brand;
        const brandCodePath = brandCode === 'choo' ? 'choo/' : '';
        const termsOfUseUrl = `https://secure.comparethemarket.com.au/static/legal/${brandCodePath}website_terms_of_use.pdf`;
        const privacyPolicyUrl = `https://secure.comparethemarket.com.au/static/legal/${brandCodePath}privacy_policy.pdf`;
        const fsgUrl = `https://secure.comparethemarket.com.au/static/legal/${brandCodePath}FSG.pdf`;
        const fsgLifeUrl = brandCode === 'choo'
            ? ''
            : ', <a target="_blank" href="https://secure.comparethemarket.com.au/static/legal/FSG_Life.pdf">Financial Services Guide (Life Insurance Products)</a> ';
        const creditGuideUrl = brandCode === 'choo' ? '' : ' and <a target="_blank" href="https://secure.comparethemarket.com.au/static/legal/CreditGuide.pdf">Credit Guide </a>';

        const disclaimer = `
        On this website you can compare quotes and purchase products from participating brands for health insurance, car
        insurance, travel insurance, life and income protection insurance, home and contents insurance, energy plans,
        roadside assistance products, home loans and credit cards.
        <br/><br/>
        We do not compare all products in the market and at times not all brands may be available. Visit each product
        page, as well as our <a target="_blank" href="${termsOfUseUrl}">Website Terms of Use</a>,
        <a target="_blank" href="${fsgUrl}">Financial Services Guide (General Insurance Products)</a>, 
        ${fsgLifeUrl} ${creditGuideUrl} for detail about who we compare, 
        how we make money and how our comparison service works for each product.
        <br/><br/>
        The Compare The Market website and trading name are owned by Compare The Market Pty Ltd ACN 117 323 378.`;

        const terms = `&copy; 2006-2017. Compare the Market. All rights reserved.
            <a href="${privacyPolicyUrl}" style="color: #ffffff" target="_blank" 
            data-id="websitePrivacyPolicyFooterLink">Privacy Policy</a>.
            <a href="${termsOfUseUrl}" style="color: #ffffff" target="_blank" 
            data-id="websiteTermsOfUseFooterLink">Website Terms of Use</a>.`;

        return (
            <div>
                <SimpleFlexbox containerFluid bgColor="body_background">
                    <SimpleFlexbox container>
                        <SimpleFlexbox row>
                            <SimpleFlexbox display="flex" xs={12} padding="all">
                                <Text
                                    innerHTML={disclaimer}
                                    tagName="p"
                                    variant="disclaimer_footer" />
                                <Anchor
                                    href="https://www.mcafeesecure.com/verify?host=www.comparethemarket.com.au"
                                    target="_blank"
                                    rel="noopener"
                                    data-id="mcAfeeImage"
                                    onContextMenu="triggerMcAfeeOnContextClick"
                                >
                                    <Picture {...pictureProps} />
                                </Anchor>
                            </SimpleFlexbox>
                        </SimpleFlexbox>
                    </SimpleFlexbox>
                </SimpleFlexbox>
                <SimpleFlexbox containerFluid bgColor="brand_base">
                    <SimpleFlexbox container>
                        <SimpleFlexbox row>
                            <SimpleFlexbox display="flex" xs={12} padding="all" contentCenter="xs">
                                <Text
                                    innerHTML="terms"
                                    tagName="span"
                                    color="brand_base_0"
                                    variant="underline_anchors" />
                            </SimpleFlexbox>
                        </SimpleFlexbox>
                    </SimpleFlexbox>
                </SimpleFlexbox>
            </div>
        );
    };

    render = () => {
        // 404 doesn't go thru the pageBuilder, so pagecontext doesn't get set. 404 renders Picture components
        // which need access to the models for the baseAssetsURL, so just set models from configModel.
        pageContext.setProp('models', configModel.getModels());
        const errorTitle = 'Whoops, sorry... looks like you\'re looking for something that isn\'t there!';
        const errorMsg = 'Sorry about that, but the page you\'re looking for can\'t be found. Either you\'ve typed the'
            + ' web address incorrectly, or the page you were looking for has been moved or deleted.';
        const urlMsg = 'Try checking the URL you used for errors, or continue browsing our range of comparison services below.';
        return (
            <SimpleFlexbox className={styles.error_container}>
                <Helmet
                    title="404 - Error Page - Compare the Market"
                />
                {this.getHeader()}
                <SimpleFlexbox containerFluid bgColor="brand_base_0">
                    <SimpleFlexbox container>
                        <SimpleFlexbox row>
                            <SimpleFlexbox xs={12} variant="404_page">
                                <h1>{errorTitle}</h1>
                                <p>{errorMsg}</p>
                                <p>{urlMsg}</p>
                            </SimpleFlexbox>
                            <SimpleFlexbox xs={12} margin="top">
                                <CrossSell />
                            </SimpleFlexbox>
                        </SimpleFlexbox>
                    </SimpleFlexbox>
                </SimpleFlexbox>
                {this.getFooter()}
            </SimpleFlexbox>
        );
    };

}

export { ErrorContainer404 };
